/**
 * Locale-aware formatting helpers (dates, numbers, currencies). Uses Intl with the active i18n locale.
 */
import i18n from "@/i18n";

const locale = () => i18n.language || "fr-CH";

export function formatDate(value, opts = { day: "2-digit", month: "short", year: "numeric" }) {
  if (!value) return "—";
  const d = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat(locale(), opts).format(d);
}

export function formatDateTime(value) {
  return formatDate(value, { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function formatTime(value) {
  return formatDate(value, { hour: "2-digit", minute: "2-digit" });
}

export function formatRelative(value) {
  if (!value) return "—";
  const d = new Date(value);
  const diff = (d.getTime() - Date.now()) / 1000;
  const rtf = new Intl.RelativeTimeFormat(locale(), { numeric: "auto" });
  const abs = Math.abs(diff);
  if (abs < 60) return rtf.format(Math.round(diff), "second");
  if (abs < 3600) return rtf.format(Math.round(diff / 60), "minute");
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), "hour");
  if (abs < 86400 * 30) return rtf.format(Math.round(diff / 86400), "day");
  return formatDate(value);
}

export function formatCurrency(value, currency = "CHF", opts = {}) {
  if (value === null || value === undefined || value === "") return "—";
  return new Intl.NumberFormat(locale(), { style: "currency", currency, maximumFractionDigits: 0, ...opts }).format(Number(value));
}

export function formatUsd(value, digits = 3) {
  if (value === null || value === undefined) return "—";
  return new Intl.NumberFormat(locale(), { style: "currency", currency: "USD", minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Number(value));
}

export function formatNumber(value, opts = {}) {
  if (value === null || value === undefined) return "—";
  return new Intl.NumberFormat(locale(), opts).format(Number(value));
}

export function formatPercent(value) {
  if (value === null || value === undefined) return "—";
  return new Intl.NumberFormat(locale(), { style: "percent", maximumFractionDigits: 0 }).format(Number(value) / 100);
}

export function toDateInputValue(value) {
  if (!value) return "";
  const d = new Date(value);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
